import type { StaticLayerPayload } from "@config";
import type { ComponentType } from "react";
import { AcceptButton } from "./AcceptButton";
import { AnimatedImage } from "./AnimatedImage";
import { AnimatedNumbers } from "./AnimatedNumbers";
import { Attachment } from "./Attachment";
import { BeforeAfter } from "./BeforeAfter";
import { Button } from "./Button";
import { Calendar } from "./Calendar";
import { Chart } from "./Chart";
import { CollapsibleText } from "./CollapsibleText";
import { Divider } from "./Divider";
import { DocumentInfo } from "./DocumentInfo";
import { Embedded } from "./Embedded";
import { Form } from "./Form";
import { Grid } from "./Grid";
import { Icon } from "./Icon";
import { Image } from "./Image";
import { Logo } from "./Logo";
import { QrCode } from "./QrCode";
import { Separator } from "./Separator";
import { RichText } from "./Text";
import { Table } from "./table";
import { Ticker } from "./ticker";
import { Video } from "./Video";

export const Elements: Record<string, ComponentType<StaticLayerPayload>> = {
  Chart,
  Divider,
  DocumentInfo,
  Embedded,
  Form,
  Icon,
  Image,
  Calendar,
  Logo,
  Separator,
  AnimatedNumbers,
  Video,
  Attachment,
  Button,
  RichText,
  Grid,
  AnimatedImage,
  AcceptButton,
  BeforeAfter,
  CollapsibleText,
  Ticker,
  Table,
  QrCode,
};
